import { render, staticRenderFns } from "./AboutSwiper1.vue?vue&type=template&id=09fa717e&scoped=true&"
import script from "./AboutSwiper1.vue?vue&type=script&lang=js&"
export * from "./AboutSwiper1.vue?vue&type=script&lang=js&"
import style0 from "./AboutSwiper1.vue?vue&type=style&index=0&id=09fa717e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fa717e",
  null
  
)

export default component.exports